import React from "react";
import { Link } from "react-router-dom";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
function Footer() {
    const date = new Date();
    const year = date.getFullYear();
    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="footer-brand">
                        <Link to="/" className="logo">
                            <h1 className="h1">
                                <span
                                    style={{ color: "white" }}
                                > DEEP</span>
                                <span>BLUE</span>
                            </h1>
                        </Link>

                        <p className="section-text">
                            Is a powerful and a flexible plartform integrated with tools to mordernise businesses, increase business revenue with enterprise-grade links built to acquire and engage customers.
                        </p>

                        <ul className="contact-list">
                            <li className="contact-link">
                                <LocationOnOutlinedIcon />
                                <address>Accra, Greater Accra, Ghana</address>

                            </li>

                            <li>
                                <a href="tel:+233200286602" className="contact-link">
                                    <CallOutlinedIcon />

                                    <span>+233 20 028 6602</span>
                                </a>
                            </li>

                            <li>
                                <a href="mailto:info@deepblue.com" className="contact-link">
                                    <EmailOutlinedIcon />

                                    <span>info@deepblue.com</span>
                                </a>
                            </li>
                        </ul>

                        <ul className="social-list">
                            <li>
                                <a href="https://www.fb.com" rel="noopener noreferer" className="social-link">
                                    <FacebookOutlinedIcon />

                                </a>
                            </li>

                            <li>
                                <a href="https://www.twitter.com/" rel="noopener noreferer" className="social-link">
                                    <TwitterIcon />
                                </a>
                            </li>

                            <li>
                                <a href="https://www.linkedin.com" rel="noopener noreferer" className="social-link">
                                    <LinkedInIcon />
                                </a>
                            </li>

                            <li>
                                <a href="https://www.youtube.com" rel="noopener noreferer" className="social-link">
                                    <YouTubeIcon />
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-link-box">
                        <ul className="footer-list">
                            <li>
                                <p className="footer-list-title">Company</p>
                            </li>

                            <li>
                                <a href="/about-us" className="footer-link">
                                    About
                                </a>
                            </li>

                            <li>
                                <a href="/resources/crm-blog" className="footer-link">
                                    CRM Blog
                                </a>
                            </li>

                            <li>
                                <a href="/about-us" className="footer-link">
                                    All Products
                                </a>
                            </li>

                            {/* <li>
                                <a href="#" className="footer-link">
                                    Locations Map
                                </a>
                            </li> */}

                            <li>
                                <a href="/resources/deepblue-faqs" className="footer-link">
                                    FAQ
                                </a>
                            </li>

                            <li>
                                <a href="/contact-us" className="footer-link">
                                    Contact us
                                </a>
                            </li>
                        </ul>

                        <ul className="footer-list">
                            <li>
                                <p className="footer-list-title">Services</p>
                            </li>
                            <li>
                                <a href="/auth" className="footer-link">
                                    Login
                                </a>
                            </li>

                            <li>
                                <a href="/auth" className="footer-link">
                                    My Account
                                </a>
                            </li>

                            <li>
                                <a href="resource/terms-and-conditions" className="footer-link">
                                    Terms & Conditions
                                </a>
                            </li>
                        </ul>
                        <ul className="footer-list">
                            <li>
                                <p className="footer-list-title">Customer Care</p>
                            </li>
                            <li>
                                <a href="/wish-list" className="footer-link">
                                    Wish List
                                </a>
                            </li>
                            <li>
                                <a href="/resources/deepblue-faqs" className="footer-link">
                                    FAQ
                                </a>
                            </li>
                            <li>
                                <a href="/promo" className="footer-link">
                                    Promotional Offers
                                </a>
                            </li>
                            <li>
                                <a href="/contact-sales" className="footer-link">
                                    Contact Sales
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">
                    <p className="copyright">
                        <a href="https://yakubulute.netlify.app/" target={"_blank"} rel="noreferrer noopener">  &copy; {year} <strong className="text-primary">DEEPBLUE </strong> All Rights Reserved.</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
